export function formatNumberToMil(value) {
  if (value > 999999) return `${Math.round((value / 1000000) * 100) / 100}M`;
  if (value > 999) return `${Math.round(value / 1000)}k`;
  return value;
}

export function formatNumbersWithComma(value) {
  return value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function formatNumbersWithNoZero(value) {
  const stringValue = value.toString();

  if (stringValue.includes('.')) {
    const [integerPart, decimalPart] = stringValue.split('.');
    const formattedDecimalPart = decimalPart.replace(/0+$/, '');
    const formattedValue = formattedDecimalPart.length
      ? `${integerPart}.${formattedDecimalPart}`
      : integerPart;

    return formattedValue;
  }

  return stringValue;
}

export function formatNumber(number) {
  return Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(number);
}

export function formatNumberWithPercent(number) {
  return `${Math.round(number * 100) / 100}%`;
}

export function getDatesDiff(d1, d2) {
  const oneDay = 24 * 60 * 60 * 1000;
  const firstDate = new Date(d1);
  const secondDate = new Date(d2);

  return Math.round(Math.abs((firstDate - secondDate) / oneDay));
}

export function formatNumberToMilV2(value) {
  if (value < 1000) {
    return value.toString();
  }
  return value > 999999
    ? `${Math.round((value / 1000000) * 100) / 100}M`
    : `${Math.round(value / 1000)}k`;
}
